<script lang="ts">
    import { getAppServices } from '$lib/services/app-services.js'
    import AccountDeletionManualRemovalDialog from './AccountDeletionManualRemovalDialog.svelte'
    import { getAccountDeletionText } from './account-deletion-text.js'

    const { accountDeletion } = getAppServices()
    const text = $derived(getAccountDeletionText())
</script>

{#if accountDeletion.state.phase === 'manual-removal-required'}
    <AccountDeletionManualRemovalDialog
        kind={accountDeletion.state.kind}
        onClose={() => accountDeletion.dismissManualRemovalNotice()}
        {text}
    />
{/if}
